import { MenuItem } from '@lokalise/louis';
import { styled } from '@lokalise/styled';

import { InlineValueEditorContainer } from '@app/components/InlineValueEditor';
import { color, spacing, typography, value } from '@app/theme';

export const StyleGuideName = styled.div`
    ${typography('body.base.strong')};

    ${InlineValueEditorContainer} {
        width: 100%;
    }
`;

export const CreatedByContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    grid-gap: ${spacing(2)};
`;

export const CreatedByName = styled.p`
    color: ${color('custom.content.primary')};
    ${typography('body.caption.default')};
`;

export const CreatedByDate = styled.p`
    color: ${color('custom.content.secondary')};
    ${typography('body.caption.default')}
`;

export const DangerMenuItem = styled(MenuItem)`
    color: ${value('color.text.danger')};
`;

export const IconMenuItem = styled(MenuItem)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const PopoverText = styled.div`
    width: 280px;
    padding: 16px;
    text-align: start;
`;
